import React, {Component,useRef} from 'react'
import './styles.css'
import {api, apiLocal} from '../../services/api'
import {apiEmployee} from '../../services/apiamrg'
import Header from '../../components/header'
import Skeleton from '../../components/skeleton'
import SkeletonPesquisa from '../../components/skeletonpesquisa'
import {Link, Redirect} from 'react-router-dom'
import {connect} from 'react-redux'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faSearch, faCoffee, faTrashAlt, faFilter,  } from '@fortawesome/free-solid-svg-icons'
import moment from 'moment'
import {PRECISA_LOGAR, NOME_EMPRESA} from '../../config'
import {confirmAlert} from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
var numbro = require("numbro");
const estadoInicial = {
    name: '',  
    usuarios: [],  
    loading: false,
    loadingPesquisa: false,
    redirect: false,
    pesquisa: '',
    expandido: false,
    seaport: 0,
    status: 'all', 
    dias_da_semana: ['Domingo','Segunda-Feira', 'Terça-Feira', 'Quarta-Feira', 'Quinta-Feira', 'Sexta-feira', 'Sabado'],
    cardapio: [],
    empresas: [],
    filempresa: 'All',
    filtipo: 'All',
    fildiadasemana: 'All',
}

class Clients extends Component {

    constructor(props) {
        super(props);
        this.pdfExportComponent = React.createRef(null);
      }
    state = {
        ...estadoInicial
    }

    componentDidMount = () => {
        this.getusuario()
    }

    getusuario = async() => {
        apiEmployee.get('pegarusuarios')
        .then(res => this.setState({
            usuarios: res.data
        }))
    }

   

    deleteService = (id, nome) => {

        confirmAlert({
            customUI: ({ onClose }) => {
              return (
                <div className='custom-ui text-center'>
                  <h1>{NOME_EMPRESA}</h1>
                  <span>Deseja remover este Cardapio?({nome})</span>
                  <button 
                      style={{marginRight: 5}}
                      className="btn btn-success w-25"
                      onClick={
                          async () => {
                              onClose()
                          }
                      }
                  >
                      Não
                  </button>
                  <button 
                      style={{marginRight: 5}}
                      className="btn btn-danger w-25"
                      onClick= {
                            async () => {
                                await apiEmployee.post(`apagarcardapio`, {
                                    chave: id
                                }).then(
                                    async response => { 
                                        if(response.data == true){
                                            alert('Cardapio removido!')
                                            document.location.reload()
                                        }
                                    },
                                    async response => {
                                        this.erroApi(response)
                                    }
                                )
                                onClose()
                            }    
                        }
                           
                    >
                      Sim
                  </button>
                </div>
              )
            }
        })
    }



    /*
    getPesquisaShips = async () => {
        await this.setState({loadingPesquisa: true})
        const pesquisa = this.state.pesquisa ? this.state.pesquisa : ' '
        //console.log(`pesquisaships/${pesquisa}/${this.state.seaport}/${this.state.status}`)
        if(this.props.online){
            await api.get(`pesquisaships/${pesquisa}/${this.state.seaport}/${this.state.status}`, {
                headers: {
                    "Content-Type": `application/x-www-form-urlencoded`,
                    "Authorization": `bearer ${this.props.token}`
                },
                
            }).then(
                response => { this.setState({ships: response.data})},
                response => {this.erroApi(response)}
            
            )
        }else{
            await apiLocal.get(`pesquisaships/${pesquisa}/${this.state.seaport}/${this.state.status}`, {
                headers: {
                    "Content-Type": `application/x-www-form-urlencoded`,
                    "Authorization": `bearer ${this.props.token}`
                },
                
            }).then(
                response => { this.setState({ships: response.data})},
                response => {this.erroApi(response)}
            
            )
        }
        await this.setState({loadingPesquisa: false})
    }



    
    filtroSeaport = (navios) => this.state.seaport != 0 ? parseInt(navios.id_seaport) === parseInt(this.state.seaport) : 1
    filtroStatus = (navios) => this.state.status != 'all' ? navios.status == this.state.status : 1
    //filtroName = (navios) => !navios.name.trim().toLowerCase().indexOf(`${this.state.pesquisa.toLowerCase()}`)
    filtroName = (navios) => navios.name.toLowerCase().includes(this.state.pesquisa.toLowerCase())
    */
    
    filtroEmpresa = (card) => {
        if(this.state.filempresa == 'All'){
            return true
        }else{
            if(card.Nome_fantasia == this.state.filempresa){
                return true
            }else{return false}
        }

    }

    filtroTipo = (card) => {
        if(this.state.filtipo == 'All'){
            return true
        }else{
            if(card.Descricao == this.state.filtipo){
                return true
            }else{return false}
        }

    }
    

    filtrodia = (card) => {
        if(this.state.fildiadasemana == 'All'){
            return true
        }else{
            let diacerto = parseInt(card.dia_semana)-1
            console.log(diacerto)
            if(diacerto == (this.state.fildiadasemana)){
                return true
            }else{return false}
        }

    }
   

    


    
    render(){
        
        return (
            <div style={{backgroundColor:'#DE3338'}}>
                <div
        style={{ 
            position: "absolute",
            left: "-900000px",
            top: 0,
          }}
      >
      </div>
                {this.state.redirect &&
                    <Redirect to={'/admin'} />
                }
                {!this.state.loading &&
                <div>
                 <section>
                    <Header voltar/>
                    
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="page-breadcrumb">
                                    <h2 id='titulo'>Usuários</h2>
                                </div>
                            </div>
                        </div>
                    
                </section>
               
               <div style={{display:'flex', justifyContent:'center',alignItems:'center', width:'100%'}}>

                    <Link  to={{
                                    pathname: `/admin/addclient/0`, 
                                    state: {usuario: undefined}
                                }} className='butaoadicionarcardapio'> Adicionar Usuario </Link>
                        <div hidden className='butaofiltros' onClick={(a) => this.setState({expandido: !this.state.expandido})}> Filtrar  <FontAwesomeIcon icon={faFilter} size="12" color='black' /> </div>    
                        
              
              
                    
               </div>
               <div style={{display:'flex', justifyContent:'center',alignItems:'center', width:'100%'}}>
               <div className={ this.state.expandido == true? 'containerselectsfilter expandido' : 'containerselectsfilter' }> 
                   
                   <div className= 'containerspanselectfilter'>
                    <span>Empresa</span>
                    <select onChange={(a) => this.setState({filempresa: a.currentTarget.selectedOptions[0].value})}>
                        <option value='All'>Todas</option>
                        {this.state.empresas.map( elemento => {
                            if(elemento.Nome_Fantasia != '' && elemento.Nome_Fantasia != undefined ) {
                            return(<option value={elemento.Nome_Fantasia}> {elemento.Nome_Fantasia} </option>)
                            }
    })}
                    </select>

                   </div>

                   
                   <div className='containerspanselectfilter'>
                    <span>Tipo</span>
                    <select onChange={(a) => this.setState({filtipo: a.currentTarget.selectedOptions[0].value})}>
                        <option value='All'>Tudo</option>
                        <option value='GRELHADO'>Grelhado</option>
                        <option value='BALCÃO DE SABORES'>Balcao De Sabores</option>
                        <option value='LIGHT'>Light</option>
                        <option value='BUFFET'>Buffet</option>
                    </select>

                   </div>

                   <div className='containerspanselectfilter'>
                    <span>Dia Da Semana</span>
                    <select onChange={(a) => this.setState({fildiadasemana: a.currentTarget.selectedOptions[0].value})}>
                        <option value='All'>Tudo</option>
                        {this.state.dias_da_semana.map((elemento,index) =>{
                            return( <option value={index}>{elemento}</option>)
                        })}
                       
                    </select>

                   </div>

                   
                   
                   
                   </div> 
               </div>
          

                    <div style={{width:'100%', display:'flex', alignItems:'center', justifyContent:'center'}}>
                   <div className='col-11 row'>
                    <div className='col-12 row arrumaraqui25'>
                    <div className='col-3'>
                        Empresa

                    </div>
                    <div className='col-3'>
                        Nome 

                    </div>

                    <div className='col-3'>
                        CPF

                    </div>
                    <div className='col-2'>
                        Bloqueado

                    </div>
                    <div className='col-1'>
                        

                    </div>


                    </div>

                       {this.state.usuarios.map((user,index) => {

                            if(index%2 == 0){
                                return(
                                    <div className='col-12 row arrumaraqui26' key={user.chave}>
                                    <Link className='col-3'  to={{
                                        pathname: `/admin/addclient/${user.chave}`, 
                                        state: {usuario: {...user}}
                                    }}>
                                        {user.Nome_Fantasia}
                
                                    </Link>
                                    <Link className='col-3'  to={{
                                        pathname: `/admin/addclient/${user.chave}`, 
                                        state: {usuario: {...user}}
                                    }}>
                                    {user.nome}
                
                                    </Link>
                
                                    <Link className='col-3'  to={{
                                        pathname: `/admin/addclient/${user.chave}`, 
                                        state: {usuario: {...user}}
                                    }}>
                                    {user.cpf}
                
                                    </Link>
                
                                    <Link className='col-2'  to={{
                                        pathname: `/admin/addclient/${user.chave}`, 
                                        state: {usuario: {...user}}
                                    }}>
                                      { user.bloqueado == "" ? "(Sem Bloqueio)": moment(user.bloqueado).format('DD/MM/YYYY')}
                
                                    </Link>

                                      <div className='col-1 lixeira' >
    
                                    
                                    <FontAwesomeIcon icon={faTrashAlt} size="12" color='black' />
                                    
                                    </div>
                
                
                                    </div>
                                )

                            }else{
                                return(
                                    <div className='col-12 row arrumaraqui27' key={user.chave}>
                                    <Link className='col-3'  to={{
                                        pathname: `/admin/addclient/${user.chave}`, 
                                        state: {usuario: {...user}}
                                    }}>
                                        {user.Nome_Fantasia}
                
                                    </Link>
                                    <Link className='col-3'  to={{
                                        pathname: `/admin/addclient/${user.chave}`, 
                                        state: {usuario: {...user}}
                                    }}>
                                    {user.nome}
                
                                    </Link>
                
                                    <Link className='col-3'  to={{
                                        pathname: `/admin/addclient/${user.chave}`, 
                                        state: {usuario: {...user}}
                                    }}>
                                    {user.cpf}
                
                                    </Link>
                
                                    <Link className='col-2'  to={{
                                        pathname: `/admin/addclient/${user.chave}`, 
                                        state: {usuario: {...user}}
                                    }}>
                                      { user.bloqueado == "" ? "(Sem Bloqueio)": moment(user.bloqueado).format('DD/MM/YYYY')}
                
                                    </Link>

                                      <div className='col-1 lixeira' >
    
                                    
                                            <FontAwesomeIcon icon={faTrashAlt} size="12" color={index % 2 == 0 ? "black" : "white"} />
                                    
                                    </div>
                
                
                                    </div>
                                )

                            }








                       })}
                 
                   







                   </div>
                   </div>
                      
                </div>
                }
            </div>
        )
        
    }
}

const mapStateToProps = ({ user, servidor }) => {
    return {
        token: user.token,
        online: servidor.online
    }
} 

export default connect(mapStateToProps, null)(Clients)
